import {
  AbsoluteCenter,
  Box,
  chakra,
  Flex,
  Image,
  shouldForwardProp,
} from "@chakra-ui/react";
import { isValidMotionProp, motion } from "framer-motion";
import React from "react";
import { COMMON_WEB_PATH } from "../../constant";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

const ChakraBox = chakra(motion.div, {
  shouldForwardProp: (prop) =>
    isValidMotionProp(prop) || shouldForwardProp(prop),
});

const WebsiteMaintainWrapper = ({ children }) => {
  const { t } = useTranslation();
  const i18n_common = (key, props) => t(`common.${key}`, { ...props });

  const isMaintain = window.is_under_maintenance;
  return isMaintain ? (
    <Box
      w="100%"
      h="100dvh"
      display="flex"
      alignItems={"center"}
      justifyContent={"center"}
    >
      <ChakraBox
        as={Flex}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.3, delay: 0.3 }}
        w="420px"
        minH="300px"
        bgImage={`url('${COMMON_WEB_PATH}/now888/modal/hintBG.webp')`}
        bgPosition="center"
        bgRepeat="no-repeat"
        bgSize="100% 100%"
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="space-between"
        position={"relative"}
        p={6}
        pt={"50px"}
      >
        <AbsoluteCenter
          display="flex"
          fontSize="24px"
          color="white"
          textAlign="center"
          mt={4}
          // bgImage={`url('${COMMON_WEB_PATH}/flyDragon/hintTitleBG.webp')`}
          bgPosition="center"
          bgRepeat="no-repeat"
          bgSize="100% 100%"
          sx={{ width: "-webkit-fill-available" }}
          justifyContent="center"
          alignItems="center"
          top="-30px"
        >
          <Image
            src={`${COMMON_WEB_PATH}/now888/modal/hintWORD${
              i18next.language == "tw" ? "" : `_${i18next.language}`
            }.webp`}
            height={{
              base: "50px",
              xl: "60px",
            }}
          />
        </AbsoluteCenter>
        <Box fontSize="24px" color="white" textAlign="center" mb={2}>
          {i18n_common("站台維護中")}
        </Box>

        <Flex
          gap={4}
          mb={4}
          justifyContent="space-between"
          alignItems="center"
        ></Flex>
      </ChakraBox>
    </Box>
  ) : (
    children
  );
};

export default WebsiteMaintainWrapper;
